"use strict";

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Returns a preconfigured loader method

function createScriptLoader(_a) {
  var snippetId = _a.snippetId,
      text = _a.text,
      url = _a.url,
      delay = _a.delay,
      waitForUserInteraction = _a.waitForUserInteraction;
  return insertScriptTag.bind(null, {
    snippetId: snippetId,
    text: text,
    url: url,
    delay: delay,
    waitForUserInteraction: waitForUserInteraction
  });
} // Sets the trap


function registerScriptLoader(_a) {
  var snippetId = _a.snippetId,
      text = _a.text,
      url = _a.url,
      delay = _a.delay,
      waitForUserInteraction = _a.waitForUserInteraction;
  var snippetKey = "loaded-" + snippetId;
  window[snippetKey] = createScriptLoader({
    snippetId: snippetId,
    text: text,
    url: url,
    delay: delay,
    waitForUserInteraction: waitForUserInteraction
  }); // listen for user interaction before adding script?

  if (waitForUserInteraction) {
    window.addEventListener('click', window[snippetKey]);
    window.addEventListener('mousemove', window[snippetKey]);
    window.addEventListener('scroll', window[snippetKey]);
    window.addEventListener('touchstart', window[snippetKey]);
  } else {
    window[snippetKey]();
  }
} // After the timeout, insert the script tag to the DOM


function insertScriptTag(_a) {
  var delay = _a.delay,
      snippetId = _a.snippetId,
      text = _a.text,
      url = _a.url;
  var snippetKey = "loaded-" + snippetId; // remove user interaction listeners

  window.removeEventListener('click', window[snippetKey]);
  window.removeEventListener('mousemove', window[snippetKey]);
  window.removeEventListener('scroll', window[snippetKey]);
  window.removeEventListener('touchstart', window[snippetKey]); // insert the script tag after delay

  setTimeout(function () {
    if (window["suppress-" + snippetId]) {
      // allow suppressing before user interaction
      return;
    }

    var scriptElem = window.document.createElement('script');
    scriptElem.id = snippetId;

    if (text) {
      scriptElem.setAttribute('type', 'text/javascript');
      scriptElem.innerHTML = text;
    } else {
      scriptElem.src = url;
      scriptElem.async = true;
      scriptElem.defer = true;
    }

    window.document.body.appendChild(scriptElem);
  }, delay);
} // export as a functional component


function ScriptLoader(props) {
  var snippetId = props.snippetId,
      text = props.text,
      url = props.url,
      delay = props.delay,
      _a = props.waitForUserInteraction,
      waitForUserInteraction = _a === void 0 ? true : _a;
  var snippetKey = "loaded-" + snippetId; // add the script loader to the window object?

  if (!window[snippetKey]) {
    registerScriptLoader({
      snippetId: snippetId,
      text: text,
      url: url,
      delay: delay,
      waitForUserInteraction: waitForUserInteraction
    });
  }

  return null;
}

exports["default"] = ScriptLoader;